import { render } from "./ModalWithSlides.vue?vue&type=template&id=40fb1240&scoped=true&ts=true"
import script from "./ModalWithSlides.vue?vue&type=script&lang=ts"
export * from "./ModalWithSlides.vue?vue&type=script&lang=ts"

import "./ModalWithSlides.vue?vue&type=style&index=0&id=40fb1240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fb1240"]])

export default __exports__